import React, { useContext, useState } from "react";
import { useMutation } from "@apollo/client";
//Import from project
import { AuthContext } from "../../../Context/AuthContext";
import {CREATE_OPTION_PRICE, UPDATE_OPTION_PRICE} from "../../../Schema/OptionPrice";

const useOptionPriceForm = ({ handleClose, resetForm, setRefetch }) => {
  // Change Language
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [createOptionPrice] = useMutation(CREATE_OPTION_PRICE, {
    onCompleted: ({ createOptionPrice }) => {
      setLoading(false);

      if (createOptionPrice?.isSuccess === true) {
        console.log("createOptionPrice::", createOptionPrice)
        setAlert(true, "success", createOptionPrice?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createOptionPrice?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  const [updateOptionPrice] = useMutation(UPDATE_OPTION_PRICE, {
    onCompleted: ({ updateOptionPrice }) => {
      setLoading(false);
      if (updateOptionPrice?.isSuccess === true) {
        setAlert(true, "success", updateOptionPrice?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", updateOptionPrice?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  return { createOptionPrice, updateOptionPrice, loading, setLoading };
};

export default useOptionPriceForm;
